module.exports = __webpack_public_path__ + "static/media/id_card_identity_icon.264ee3a7.svg";